import * as Yup from "yup";

import { DISTANCE_UNIT } from "../../constants";

export const featuresModalSchema = Yup.object().shape({
  amenity: Yup.object().shape({
    // flooringTypeId: Yup.number().required("Flooring Type is required"),
    // electricityBackupId: Yup.number().required(
    //   "Electricity Backup is required"
    // ),
    // builtInYear: Yup.string().required("Build In Year is required"),
    // parkingSpace: Yup.number().required("Parking Space is required"),
    // floors: Yup.number().required("Floors is required"),
    // propertyViewId: Yup.number().required("Property View is required"),
    // featureIds: Yup.array()
    //   .of(Yup.number())
    //   .min(1, "At least one feature is required")
    //   .required("Features are required"),
    // otherRooms: Yup.string().required("Other Rooms is required"),
    // staffQuarters: Yup.string().required("Staff Quarters is required"),
    // kitchens: Yup.string().required("Kitchens is required"),
    // storeRooms: Yup.string().required("Store rooms is required"),
    // roomsIds: Yup.array()
    //   .of(Yup.number())
    //   .min(1, "At least one room is required")
    //   .required("Rooms are required"),
    // facilitesIds: Yup.array()
    //   .of(Yup.number())
    //   .min(1, "At least one facility is required")
    //   .required("Facilities are required"),
    nearbyLocations: Yup.array().of(
      Yup.object().shape({
        type: Yup.number().required(),
        name: Yup.string()
          .trim()
          .min(1, "Name should contain atleast 1 character")
          .max(200, "Name must not exceed 200 characters")
          .required("Location name is required"),
        distance: Yup.number()
          .required("Location distance is required")
          .min(0, "Distance cannot be negative"),
        distanceKm: Yup.number()
          .required("Location distance is required")
          .min(0, "Distance cannot be negative"),
        distanceUnit: Yup.number()
          .required("Distance unit is required")
          .oneOf(
            [DISTANCE_UNIT.MILES, DISTANCE_UNIT.KILOMETERS],
            "Invalid distance unit"
          ),
      })
    ),
  }),
});
